export const SUPPLIER_ID = 'supplierId';
export const SUPPLIER_LIST = 'supplierList';
export const EMPTY = '-';
